export enum FeeType {
  PERCENTAGE = 'PERCENTAGE',
  FLAT = 'FLAT',
}
